module.exports = __webpack_public_path__ + "img/down_arrow.dccb3574.svg";